import {FETCH_DAILYMASS} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_DAILYMASS:
            return action.payload;
        default:
            return state;
    }
}